
import { useState, useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { useNotify } from '@/hooks/useNotify';
import { AdminUser } from '@/lib/types';

export const useUsersData = () => {
  const [users, setUsers] = useState<AdminUser[]>([]);
  const [loading, setLoading] = useState(true);
  const notify = useNotify();

  const fetchUsers = async () => {
    setLoading(true);
    
    try {
      const { data, error } = await supabase.rpc('get_all_platform_users');

      if (error) throw error;

      setUsers((data || []).map((row: any) => ({
        id: row.id,
        role: (row.admin_role === 'admin' || row.admin_role === 'superuser') ? row.admin_role : 'user',
        is_active: row.is_active,
        status: row.status || 'active',
        created_at: '',
        company_name: row.company_name || null,
        company_position: row.company_position || '',
        personal_phone_number: row.personal_phone_number || '',
        profiles: {
          first_name: row.first_name || 'Unknown',
          last_name: row.last_name || 'User',
          email: row.email || 'No email'
        }
      })));
    } catch (error) {
      console.error('Error fetching users data:', error);
      notify.error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUsers();
  }, []);

  return {
    users,
    setUsers,
    loading,
    refetch: fetchUsers
  };
};
